/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Tue Nov 14 2023
 **/

import { DependencyList, useEffect } from "react";
import { Observable, Observer, Subscription } from "rxjs";

type EventSubscription = Subscription[];

export default function useAutoEvent<T>(
	events: {
		event: Observable<T>;
		handler: Partial<Observer<T>> | ((value: T) => void);
	}[],
	deps: DependencyList = []
) {
	useEffect(() => {
		const eventHandlers: EventSubscription = [];
		for (const event of events) {
			eventHandlers.push(event.event.subscribe(event.handler));
		}
		return () => {
			for (const handler of eventHandlers) {
				handler?.unsubscribe();
			}
		};
	}, deps);
}
